module.exports = __webpack_public_path__ + "static/media/coursereport-cities.f69ff695.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/coursereport-cities.png
// module id = 476
// module chunks = 0